{
  "academic-title-type.actions.sync.button.trigger.text": "Synchronizovať",
  "academic-title-type.actions.sync.content.text": "Naozaj chcete synchronizovať typy titulov?",
  "academic-title-type.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "academic-title-type.columns.id": "Id",
  "academic-title-type.columns.title": "Názov",
  "academic-title-type.evidence.table.title": "Typ titulu",
  "academic-title-type.fields.title.label": "Názov",
  "academic-title-type.tabs.base-info": "Základné informácie",

  "academic-title.actions.sync.button.trigger.text": "Synchronizovať",
  "academic-title.actions.sync.content.text": "Naozaj chcete synchronizovať tituly?",
  "academic-title.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "academic-title.columns.code": "Kód",
  "academic-title.columns.id": "Id",
  "academic-title.columns.title": "Názov",
  "academic-title.evidence.table.title": "Tituly",
  "academic-title.fields.code.label": "Kód",
  "academic-title.fields.title.label": "Názov",
  "academic-title.fields.type.label": "Typ",
  "academic-title.tabs.base-info": "Základné informácie",

  "address-type.actions.sync.button.trigger.text": "Synchronizovať",
  "address-type.actions.sync.content.text": "Naozaj chcete synchronizovať typ adresy?",
  "address-type.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "address-type.columns.code.label": "Kód",
  "address-type.columns.id.label": "Id",
  "address-type.columns.title.label": "Názov",
  "address-type.evidence.table.title": "Typ adresy",
  "address-type.fields.code.label": "Kód",
  "address-type.fields.external-code.label": "Externý kód",
  "address-type.fields.title.label": "Názov",
  "address-type.fields.uid.label": "UID",
  "address-type.fields.valid-to.label": "Platnosť do",
  "address-type.tabs.base-info": "Základné informácie",

  "address.dialog.title": "Adresa",
  "address.fields.address-point.label": "Adresný bod",
  "address.fields.address-type.label": "Typ adresy",
  "address.fields.address-type.seat": "Sídlo",
  "address.fields.country.label": "Štát",
  "address.fields.county.label": "Okres",
  "address.fields.descriptive-number.label": "Súpisné číslo",
  "address.fields.municipality-part.label": "Časť obce",
  "address.fields.municipality.label": "Obec",
  "address.fields.municipality.placeholder": "Vyberte obec nebo zadejte text",
  "address.fields.orientation-number.label": "Orientačné číslo",
  "address.fields.street.label": "Ulica",
  "address.fields.zip-code.label": "PSČ",
  "address.seat.title": "Sídlo",
  "address.title": "Adresa",

  "audit.history.author.system": "Systém",

  "calendar.day-events-dialog.title": "Udalosti dňa {date}",
  "calendar.event-detail-dialog.title": "Udalosť",
  "calendar.header.next.label": "Nasledujúci",
  "calendar.header.next.placeholder": "Nasledujúci",
  "calendar.header.previous.label": "Predchádzajúci",
  "calendar.header.previous.placeholder": "Predchádzajúci",
  "calendar.header.select-date.label": "Vybrať dátum",
  "calendar.header.select-date.placeholder": "Vybrať dátum",
  "calendar.header.today": "Dnes",
  "calendar.view.month-grid": "Mesiac",
  "calendar.view.week": "Týždeň",

  "components.search-input.is-fetching": "Načítava sa...",
  "components.search-input.no-data": "Žiadne údaje",

  "country.actions.sync.button.trigger.text": "Synchronizovať",
  "country.actions.sync.content.text": "Naozaj chcete synchronizovať štáty?",
  "country.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "country.columns.code.label": "Kód",
  "country.columns.id.label": "Id",
  "country.columns.iso2.label": "ISO2",
  "country.columns.title.label": "Názov",
  "country.detail.fields.alias.label": "Skratka",
  "country.detail.fields.code.label": "Kód",
  "country.detail.fields.iso2.label": "ISO2",
  "country.detail.fields.iso3.label": "ISO3",
  "country.detail.fields.title.label": "Názov",
  "country.detail.groups.basic-info.title": "Základné údaje",
  "country.detail.tabs.basic-info.label": "Základné údaje",
  "country.evidence.table.title": "Zoznam krajín",

  "county.actions.sync.button.trigger.text": "Synchronizovať",
  "county.actions.sync.content.text": "Naozaj chcete spustiť synchronizáciu okresov?",
  "county.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "county.columns.code.label": "Kód",
  "county.columns.region-identifier.label": "Identifikátor kraja",
  "county.columns.title.label": "Názov",
  "county.detail.fields.change-id.label": "ID zmeny",
  "county.detail.fields.changed-at.label": "Zmenené dňa",
  "county.detail.fields.code.label": "Kód",
  "county.detail.fields.codelist-code.label": "Kód číselníka",
  "county.detail.fields.created-reason.label": "Dôvod vytvorenia",
  "county.detail.fields.database-operation.label": "Databázová operácia",
  "county.detail.fields.effective-date.label": "Dátum účinnosti",
  "county.detail.fields.object-id.label": "ID objektu",
  "county.detail.fields.region-identifier.label": "Identifikátor kraja",
  "county.detail.fields.register-id.label": "ID položky",
  "county.detail.fields.title.label": "Názov",
  "county.detail.fields.valid-from.label": "Platnosť od",
  "county.detail.fields.valid-to.label": "Platnosť do",
  "county.detail.fields.version-id.label": "ID verzie",
  "county.detail.groups.basic-info.title": "Základné údaje",
  "county.detail.tabs.basic-info.label": "Základné údaje",
  "county.evidence.table.title": "Zoznam okresov",

  "dashboard.text.empty-dashboard": "Pridajte widgety na nástenku.",
  "dashboard.toast.layout-reset": "Štruktúra nástenky bola zmenená, rozloženie bolo obnovené na predvolené nastavenie.",

  "data-form.confirm-dialog.subtitle": "Túto akciu nemožno vrátiť späť.",
  "data-form.confirm-dialog.title": "Záznam bude vymazaný",
  "data-form.delete": "Vymazať",
  "data-form.delete.error": "Nepodarilo sa vymazať záznam.",
  "data-form.submit.sucess.title": "Údaje boli úspešne vymazané.",

  "data-table.refetch": "Načítať znova",
  "data-table.refetch-error": "Pri načítavaní údajov sa vyskytla chyba",
  "data-table.refetch-success": "Údaje boli znova načítané",
  "data-table.search": "Hľadať",
  "data-table.settings": "Nastavenia",

  "department-type.columns.code.label": "Kód",
  "department-type.columns.level.label": "Úroveň",
  "department-type.columns.title.label": "Názov",
  "department-type.detail.fields.code.label": "Kód",
  "department-type.detail.fields.description.label": "Popis",
  "department-type.detail.fields.level.label": "Úroveň",
  "department-type.detail.fields.title.label": "Názov",
  "department-type.detail.groups.basic-info.title": "Základné údaje",
  "department-type.detail.tabs.basic-info.label": "Základné údaje",
  "department-type.evidence.table.title": "Typy organizačných útvarov",

  "dictionary-evidence.code": "Kód",

  "evidence.layout.buttons.close-detail.text": "Zavrieť detail",

  "export.actions.export.buttons.confirm.disabled.tooltip": "Šírka tabuľky presahuje maximálnu šírku pre PDF",
  "export.actions.export.buttons.confirm.text": "Exportovať",
  "export.actions.export.buttons.trigger.text": "Export",
  "export.actions.export.fields.definition.label": "Šablóna",
  "export.actions.export.fields.type.label": "Formát",
  "export.actions.export.pdfWidthExceeded": "PDF export nemožno spustiť, pretože vybrané stĺpce sú širšie než strana A4.",
  "export.actions.export.title": "Export",
  "export.actions.export.toast.completed.title": "Export je pripravený na stiahnutie",
  "export.actions.export.toast.download.button.text": "Stiahnuť export",
  "export.actions.export.toast.failed.title": "Nepodarilo sa vygenerovať export",
  "export.actions.export.toast.generating.title": "Prebieha generovanie exportu",
  "export.format.csv": "CSV",
  "export.format.docx": "DOCX",
  "export.format.html": "HTML",
  "export.format.pdf": "PDF",
  "export.format.xlsx": "XLSX",
  "export.format.xml": "XML",

  "forms.form-submission.columns.template.label": "Šablóna",
  "forms.form-submission.evidence.table.title": "Vyplnené formuláre",
  "forms.form-submission.fields.template.label": "Šablóna",
  "forms.form-submission.html-preview.dialog.title": "Náhľad formulára",
  "forms.form-submission.html-preview.error": "Nepodarilo sa načítať náhľad vyplneného formulára.",
  "forms.form-submission.html-preview.toolbar.tooltip": "Náhľad formulára",
  "forms.form-submission.preview.loading-template": "Načítava sa šablóna na náhľad formulára...",
  "forms.form-submission.preview.no-template": "Vyplnenému formuláru chýba referencia na šablónu.",
  "forms.form-submission.preview.template-not-found": "Nepodarilo sa načítať šablónu formulára.",
  "forms.form-submission.tabs.base-info.group.basic": "Základné informácie",
  "forms.form-submission.tabs.base-info.label": "Základné informácie",
  "forms.form-submission.tabs.preview.label": "Náhľad formulára",
  "forms.form-submission.validation.payload.invalid": "Údaje musia obsahovať platný JSON.",
  "forms.form-template.columns.active.label": "Aktívna",
  "forms.form-template.columns.phase.label": "Fáza prípadu",
  "forms.form-template.columns.system.label": "Systémová",
  "forms.form-template.columns.title.label": "Názov",
  "forms.form-template.columns.type.label": "Typ šablóny",
  "forms.form-template.columns.upvs-form.label": "UPVS formulár",
  "forms.form-template.evidence.table.title": "Šablóny formulárov",
  "forms.form-template.fields.active.label": "Aktívna",
  "forms.form-template.fields.default-values.actions.generate": "Vygenerovať",
  "forms.form-template.fields.default-values.label": "Predvolené hodnoty",
  "forms.form-template.fields.description.label": "Popis",
  "forms.form-template.fields.entity-mapping.actions.generate": "Vygenerovať",
  "forms.form-template.fields.entity-mapping.label": "Mapovanie na entitu {entity}",
  "forms.form-template.fields.json-schema.label": "Schéma JSON",
  "forms.form-template.fields.phase.label": "Fáza prípadu",
  "forms.form-template.fields.system.label": "Systémová",
  "forms.form-template.fields.system.tooltip": "Systémovú šablónu vytvára aplikácia a nie je možné ju vymazať.",
  "forms.form-template.fields.tags.label": "Značky",
  "forms.form-template.fields.tags.tooltip": "Technické značky používané na radenie šablón podľa relevantnosti pri vytváraní záznamov.",
  "forms.form-template.fields.title.label": "Názov",
  "forms.form-template.fields.type.label": "Typ šablóny",
  "forms.form-template.fields.ui-schema.label": "Schéma UI",
  "forms.form-template.fields.upvs-form.label": "UPVS formulár",
  "forms.form-template.fields.user-mapping.actions.generate": "Vygenerovať",
  "forms.form-template.fields.user-mapping.label": "Mapovanie na prihláseného používateľa",
  "forms.form-template.tabs.base-info.group.basic": "Základné informácie",
  "forms.form-template.tabs.base-info.label": "Základné informácie",
  "forms.form-template.tabs.data-mapping.label": "Mapovanie údajov",
  "forms.form-template.tabs.history.label": "História zmien",
  "forms.form-template.tabs.schemas.label": "Schémy",
  "forms.form-template.tabs.upvs-form.label": "UPVS formulár",
  "forms.form-template.validation.default-values.invalid": "Predvolené hodnoty musia obsahovať platný JSON alebo byť prázdne.",
  "forms.form-template.validation.entity-mapping.invalid": "Mapovanie entity musí obsahovať platný JSON alebo byť prázdne.",
  "forms.form-template.validation.json-schema.invalid": "Schéma JSON musí byť platným JSON.",
  "forms.form-template.validation.ui-schema.invalid": "Schéma UI musí byť platným JSON.",
  "forms.form-template.validation.upvs-form.required": "Formulár UPVS je povinný.",
  "forms.form-template.validation.user-mapping.invalid": "Mapovanie prihláseného používateľa musí obsahovať platný JSON alebo byť prázdne.",
  "forms.html-preview.empty": "Náhľad dokumentu nie je k dispozícii.",
  "forms.html-preview.iframe.title": "Náhľad dokumentu",
  "forms.html-preview.loading": "Pripravuje sa náhľad dokumentu...",
  "forms.runtime.invalid-schema": "Šablóna neobsahuje platnú schému JSON/UI. Formulár nemožno vykresliť.",
  "forms.runtime.validation.default": "Neplatná hodnota",
  "forms.runtime.validation.enum": "Vyberte jednu z povolených hodnôt",
  "forms.runtime.validation.exclusive-maximum": "Musí byť menšie ako {limit}",
  "forms.runtime.validation.exclusive-minimum": "Musí byť väčšie ako {limit}",
  "forms.runtime.validation.format.date": "Neplatný dátum",
  "forms.runtime.validation.format.date-time": "Neplatný dátum a čas",
  "forms.runtime.validation.format.email": "Neplatná e-mailová adresa",
  "forms.runtime.validation.format.time": "Neplatný čas",
  "forms.runtime.validation.format.uri": "Neplatná URL adresa",
  "forms.runtime.validation.integer": "Musí byť celé číslo",
  "forms.runtime.validation.invalid": "Formulár obsahuje neplatné hodnoty.",
  "forms.runtime.validation.max-items": "Môže obsahovať najviac {limit, plural, one {# položku} few {# položky} other {# položiek}}",
  "forms.runtime.validation.max-length": "Môže obsahovať najviac {limit, plural, one {# znak} few {# znaky} other {# znakov}}",
  "forms.runtime.validation.maximum": "Môže byť najviac {limit}",
  "forms.runtime.validation.min-items": "Musí obsahovať aspoň {limit, plural, one {# položku} few {# položky} other {# položiek}}",
  "forms.runtime.validation.min-length": "Musí obsahovať aspoň {limit, plural, one {# znak} few {# znaky} other {# znakov}}",
  "forms.runtime.validation.minimum": "Musí byť aspoň {limit}",
  "forms.runtime.validation.multiple-of": "Musí byť násobkom {limit}",
  "forms.runtime.validation.number": "Musí byť číslo",
  "forms.runtime.validation.pattern": "Neplatný formát",
  "forms.runtime.validation.required": "Povinné pole",

  "gender.actions.sync.button.trigger.text": "Synchronizovať",
  "gender.actions.sync.content.text": "Naozaj chcete synchronizovať pohlavia?",
  "gender.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "gender.columns.code.label": "Kód",
  "gender.columns.title.label": "Názov",
  "gender.evidence.table.title": "Pohlavia",
  "gender.fields.alias.label": "Alias",
  "gender.fields.code.label": "Kód",
  "gender.fields.title.label": "Názov",
  "gender.tabs.base-info": "Základné informácie",

  "health-insurance.actions.sync.button.trigger.text": "Synchronizovať",
  "health-insurance.actions.sync.content.text": "Naozaj chcete synchronizovať zdravotné poisťovne?",
  "health-insurance.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "health-insurance.columns.code.label": "Kód",
  "health-insurance.columns.contact-person.label": "Kontaktná osoba",
  "health-insurance.columns.ico.label": "IČO",
  "health-insurance.columns.id.label": "Id",
  "health-insurance.columns.phone-number.label": "Telefónne číslo",
  "health-insurance.columns.title.label": "Názov poisťovne",
  "health-insurance.columns.valid-from.label": "Od",
  "health-insurance.columns.valid-to.label": "Do",
  "health-insurance.evidence.table.title": "Zdravotné poisťovne",
  "health-insurance.fields.code.label": "Kód",
  "health-insurance.fields.contact-person.label": "Kontaktná osoba",
  "health-insurance.fields.ico.label": "IČO",
  "health-insurance.fields.phone-number.label": "Telefónne číslo",
  "health-insurance.fields.successor.label": "Nástupca",
  "health-insurance.fields.title.label": "Názov",
  "health-insurance.fields.valid-from.label": "Od",
  "health-insurance.fields.valid-to.label": "Do",
  "health-insurance.tabs.base-info": "Základné informácie",
  "health-insurance.tabs.base-info.group.address": "Adresa",
  "health-insurance.tabs.base-info.group.info": "Základné informácie",

  "home.actions.add-widget.description": "Vyberte widget, ktorý chcete pridať na svoju domovskú stránku.",
  "home.actions.add-widget.no-options": "Nie sú dostupné žiadne ďalšie widgety na pridanie.",
  "home.actions.add-widget.title": "Pridať widget",
  "home.actions.add-widget.tooltip": "Pridať nový widget",

  "instance.state.active": "Aktívny",
  "instance.state.completed": "Dokončený",
  "instance.state.failed": "Neúspešný",
  "instance.state.waiting": "Čaká",

  "legal-form.actions.sync.button.trigger.text": "Synchronizovať",
  "legal-form.actions.sync.content.text": "Naozaj chcete synchronizovať právne formy?",
  "legal-form.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "legal-form.columns.code.label": "Kód",
  "legal-form.columns.id.label": "Id",
  "legal-form.columns.title.label": "Názov",
  "legal-form.evidence.table.title": "Právne formy",
  "legal-form.fields.abbreviation.label": "Skratka",
  "legal-form.fields.additional-info.label": "Doplňujúce informácie",
  "legal-form.fields.code.label": "Kód",
  "legal-form.fields.excludes.label": "Nezahŕňa",
  "legal-form.fields.form-code.label": "Kód formy",
  "legal-form.fields.includes-also.label": "Zahŕňa aj",
  "legal-form.fields.includes.label": "Zahŕňa",
  "legal-form.fields.info-en.label": "Informácie (EN)",
  "legal-form.fields.info.label": "Informácie",
  "legal-form.fields.medium-title-en.label": "Stredný názov (EN)",
  "legal-form.fields.medium-title.label": "Stredný názov",
  "legal-form.fields.note-en.label": "Poznámka (EN)",
  "legal-form.fields.note.label": "Poznámka",
  "legal-form.fields.official-title-en.label": "Oficiálny názov (EN)",
  "legal-form.fields.official-title.label": "Oficiálny názov",
  "legal-form.fields.short-title-en.label": "Krátky názov (EN)",
  "legal-form.fields.short-title.label": "Krátky názov",
  "legal-form.fields.sort-number.label": "Poradové číslo",
  "legal-form.fields.title.label": "Názov",
  "legal-form.fields.unit-of-measure.label": "Merná jednotka",
  "legal-form.fields.valid-from.label": "Od",
  "legal-form.fields.valid-to.label": "Do",
  "legal-form.tabs.base-info": "Základné informácie",
  "legal-form.tabs.base-info.group.info": "Základné informácie",

  "medical-specialty.actions.sync.button.trigger.text": "Synchronizovať",
  "medical-specialty.actions.sync.content.text": "Naozaj chcete synchronizovať medicínske špecializácie?",
  "medical-specialty.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "medical-specialty.columns.code.label": "Kód",
  "medical-specialty.columns.id.label": "Id",
  "medical-specialty.columns.specification.label": "Špecifikácia",
  "medical-specialty.columns.title.label": "Názov",
  "medical-specialty.detail.tabs.basic-info.label": "Základné údaje",
  "medical-specialty.evidence.table.title": "Zoznam medicínskych špecializácií",
  "medical-specialty.fields.code-value.label": "Kód OID",
  "medical-specialty.fields.code.label": "Kód",
  "medical-specialty.fields.description.label": "Popis",
  "medical-specialty.fields.specification.label": "Špecifikácia",
  "medical-specialty.fields.title.label": "Názov",
  "medical-specialty.tabs.base-info": "Základné informácie",

  "municipality-part.actions.sync.button.trigger.text": "Synchronizovať",
  "municipality-part.actions.sync.content.text": "Naozaj chcete spustiť synchronizáciu častí obcí?",
  "municipality-part.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "municipality-part.columns.code.label": "Kód",
  "municipality-part.columns.municipality-identifier.label": "Identifikátor obce",
  "municipality-part.columns.title.label": "Názov",
  "municipality-part.detail.fields.change-id.label": "ID zmeny",
  "municipality-part.detail.fields.changed-at.label": "Zmenené dňa",
  "municipality-part.detail.fields.code.label": "Kód",
  "municipality-part.detail.fields.codelist-code.label": "Kód číselníka",
  "municipality-part.detail.fields.created-reason.label": "Dôvod vytvorenia",
  "municipality-part.detail.fields.database-operation.label": "Databázová operácia",
  "municipality-part.detail.fields.effective-date.label": "Dátum účinnosti",
  "municipality-part.detail.fields.municipality-identifier.label": "Identifikátor obce",
  "municipality-part.detail.fields.object-id.label": "ID objektu",
  "municipality-part.detail.fields.register-id.label": "ID položky",
  "municipality-part.detail.fields.title.label": "Názov",
  "municipality-part.detail.fields.unique-numbering.label": "Jedinečné číslovanie",
  "municipality-part.detail.fields.valid-from.label": "Platnosť od",
  "municipality-part.detail.fields.valid-to.label": "Platnosť do",
  "municipality-part.detail.fields.version-id.label": "ID verzie",
  "municipality-part.detail.groups.basic-info.title": "Základné údaje",
  "municipality-part.detail.tabs.basic-info.label": "Základné údaje",
  "municipality-part.evidence.table.title": "Zoznam častí obcí",

  "municipality.actions.sync.button.trigger.text": "Synchronizovať",
  "municipality.actions.sync.content.text": "Naozaj chcete spustiť synchronizáciu obcí?",
  "municipality.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "municipality.columns.code.label": "Kód",
  "municipality.columns.county-identifier.label": "Identifikátor okresu",
  "municipality.columns.status.label": "Stav",
  "municipality.columns.title.label": "Názov",
  "municipality.detail.fields.change-id.label": "ID zmeny",
  "municipality.detail.fields.changed-at.label": "Zmenené dňa",
  "municipality.detail.fields.code.label": "Kód",
  "municipality.detail.fields.codelist-code.label": "Kód číselníka",
  "municipality.detail.fields.county-identifier.label": "Identifikátor okresu",
  "municipality.detail.fields.created-reason.label": "Dôvod vytvorenia",
  "municipality.detail.fields.database-operation.label": "Databázová operácia",
  "municipality.detail.fields.effective-date.label": "Dátum účinnosti",
  "municipality.detail.fields.object-id.label": "ID objektu",
  "municipality.detail.fields.register-id.label": "ID položky",
  "municipality.detail.fields.status.label": "Stav",
  "municipality.detail.fields.title.label": "Názov",
  "municipality.detail.fields.valid-from.label": "Platnosť od",
  "municipality.detail.fields.valid-to.label": "Platnosť do",
  "municipality.detail.fields.version-id.label": "ID verzie",
  "municipality.detail.groups.basic-info.title": "Základné údaje",
  "municipality.detail.tabs.basic-info.label": "Základné údaje",
  "municipality.evidence.table.title": "Zoznam obcí",

  "notification.preferences.saved": "Nastavenia boli uložené.",
  "notification.type.application": "Aplikačné",
  "notification.type.email": "E-mailová",

  "notifications.preferences.save": "Uložiť",
  "notifications.preferences.title": "Nastavenia preferencií",

  "organizational-unit.columns.alias.label": "Skratka",
  "organizational-unit.columns.code.label": "Kód",
  "organizational-unit.columns.department-type.label": "Typ útvaru",
  "organizational-unit.columns.parent.label": "Nadradený útvar",
  "organizational-unit.columns.title.label": "Názov",
  "organizational-unit.detail.fields.alias.label": "Skratka",
  "organizational-unit.detail.fields.code.label": "Kód",
  "organizational-unit.detail.fields.department-type-code.label": "Kód typu útvaru",
  "organizational-unit.detail.fields.department-type.label": "Typ útvaru",
  "organizational-unit.detail.fields.description.label": "Popis",
  "organizational-unit.detail.fields.parent-code.label": "Kód nadradeného útvaru",
  "organizational-unit.detail.fields.parent.label": "Nadradený útvar",
  "organizational-unit.detail.fields.title.label": "Názov",
  "organizational-unit.detail.groups.basic-info.title": "Základné údaje",
  "organizational-unit.detail.tabs.basic-info.label": "Základné údaje",
  "organizational-unit.evidence.table.title": "Organizačné útvary",

  "policy.eligibility.error": "Nepodarilo sa načítať podmienky akcie. Akciu teraz nemožno vykonať.",
  "policy.eligibility.loading": "Overujú sa podmienky akcie…",

  "region.actions.sync.button.trigger.text": "Synchronizovať",
  "region.actions.sync.content.text": "Naozaj chcete spustiť synchronizáciu krajov?",
  "region.actions.sync.toast.success.text": "Synchronizácia bola spustená",
  "region.columns.code.label": "Kód",
  "region.columns.title.label": "Názov",
  "region.detail.fields.code.label": "Kód",
  "region.detail.fields.title.label": "Názov",
  "region.detail.groups.basic-info.title": "Základné údaje",
  "region.detail.tabs.basic-info.label": "Základné údaje",
  "region.evidence.table.title": "Zoznam krajov",

  "register.columns.active.label": "Aktívny",

  "registry-file.access-type.option.read": "Čítanie",
  "registry-file.access-type.option.write": "Zápis",
  "registry-file.actions.open-detail": "Detail spisu",
  "registry-file.actions.sync.button.trigger.text": "Synchronizovať",
  "registry-file.actions.sync.content.text": "Naozaj chcete spustiť synchronizáciu spisu?",
  "registry-file.actions.sync.toast.success.text": "Synchronizácia bola dokončená",
  "registry-file.detail.access.title": "Prístupy k spisu",
  "registry-file.detail.base-info.title": "Základné údaje",
  "registry-file.detail.tabs.base-info": "Základné údaje",
  "registry-file.detail.tabs.records": "Záznamy",
  "registry-file.evidence.table.title": "Spisy",
  "registry-file.fields.additional-user-accesses.label": "Ďalšie používateľské prístupy",
  "registry-file.fields.ais-number.label": "Číslo AIS",
  "registry-file.fields.last-synced-at.label": "Posledná úspešná synchronizácia s RIS",
  "registry-file.fields.note.label": "Poznámka",
  "registry-file.fields.processor.label": "Spracovateľ",
  "registry-file.fields.ris-closed-date.label": "Dátum uzatvorenia spisu v RIS",
  "registry-file.fields.ris-id.label": "RIS ID",
  "registry-file.fields.ris-number.label": "Číslo RIS",
  "registry-file.static-layout-group.title": "Spis",

  "registry-record.detail.base-info.title": "Základné údaje",
  "registry-record.detail.tabs.base-info": "Základné údaje",
  "registry-record.detail.tabs.content": "Obsah záznamu",
  "registry-record.fields.ais-number.label": "Číslo AIS",
  "registry-record.fields.attachments.label": "Prílohy",
  "registry-record.fields.file.label": "Spis",
  "registry-record.fields.finalized.label": "Záznam je finalizovaný",
  "registry-record.fields.last-synced-at.label": "Posledná úspešná synchronizácia s RIS",
  "registry-record.fields.note.label": "Poznámka",
  "registry-record.fields.ris-id.label": "RIS ID",
  "registry-record.fields.ris-number.label": "Číslo RIS",
  "registry-record.fields.state.label": "Stav",
  "registry-record.fields.template.label": "Šablóna záznamu",
  "registry-record.fields.type.label": "Typ",
  "registry-record.finalize.error": "Pri finalizácii záznamu došlo k chybe.",
  "registry-record.preview.dialog.title": "Náhľad záznamu",
  "registry-record.preview.html.error": "Nepodarilo sa načítať náhľad záznamu.",
  "registry-record.preview.toolbar.tooltip": "Náhľad záznamu",
  "registry-record.state.cancelled": "Zrušený",
  "registry-record.state.received-assigned-to-department": "Prijatý: pridelený na agendu/útvar",
  "registry-record.state.received-completed": "Prijatý: vybavený",
  "registry-record.state.received-new-at-registry": "Prijatý: nový na podateľni",
  "registry-record.state.received-returned-to-department": "Prijatý: vrátený od spracovateľa",
  "registry-record.state.received-returned-to-registry": "Prijatý: vrátený z útvaru",
  "registry-record.state.received-unprocessed-by-handler": "Prijatý: nevybavený u spracovateľa",
  "registry-record.state.sent-approved": "Vytvorený: autorizovaný",
  "registry-record.state.sent-final": "Vytvorený a vybavený",
  "registry-record.state.sent-legal-effect": "Vytvorený: právoplatný",
  "registry-record.state.sent-new": "Vytvorený: nový záznam u spracovateľa",
  "registry-record.state.sent-pending-legal-effect": "Vytvorený: čaká na nadobudnutie právoplatnosti",
  "registry-record.state.sent-rejected": "Vytvorený: autorizácia zamietnutá",
  "registry-record.state.sent-unapproved": "Vytvorený: čaká na schválenie",
  "registry-record.state.undefined": "Neurčený",
  "registry-record.type.incoming": "Prijatý",
  "registry-record.type.internal": "Interný",
  "registry-record.type.outgoing": "Odoslaný",

  "registry.actions.open-ris-detail": "Detail v RIS",

  "related-cases.add": "Pridať prepojenie",
  "related-cases.add.success": "Prepojenia boli úspešne pridané.",
  "related-cases.add.title": "Pridať súvisiace prípady a správne konania",
  "related-cases.columns.actions": "Akcie",
  "related-cases.columns.case-id": "ID prípadu/konania",
  "related-cases.columns.source-system": "Systém",
  "related-cases.open-detail": "Otvoriť detail",
  "related-cases.pip-combobox.label": "Pridať prípad PIP",
  "related-cases.pip-combobox.tooltip": "Vyhľadávanie podľa ID, názvu alebo čísla PIP prípadu.",
  "related-cases.remove": "Odstrániť",
  "related-cases.remove.confirm": "Naozaj si prajete odstrániť väzbu na prípad alebo správne konanie?",
  "related-cases.remove.success": "Prepojenie bolo úspešne odstránené.",
  "related-cases.remove.title": "Odstrániť prepojenie",
  "related-cases.sk-combobox.label": "Pridať správne konanie",
  "related-cases.sk-combobox.tooltip": "Vyhľadávanie podľa čísla správneho konania.",
  "related-cases.source.pip": "IS PIP",
  "related-cases.source.sk": "IS SK",
  "related-cases.title": "Súvisiace prípady a správne konania",

  "rest-message.columns.duration": "Trvanie (ms)",
  "rest-message.columns.http-status": "Stav HTTP",
  "rest-message.columns.method": "Metóda",
  "rest-message.columns.service": "Služba",
  "rest-message.columns.uri": "URI",
  "rest-message.fields.duration": "Trvanie (ms)",
  "rest-message.fields.http-status": "Stav HTTP",
  "rest-message.fields.method": "Metóda",
  "rest-message.fields.service": "Služba",
  "rest-message.fields.uri": "URI",
  "rest-message.groups.communication": "Komunikácia REST",
  "rest-message.groups.error": "Chyba",
  "rest-message.groups.request": "Požiadavka",
  "rest-message.groups.response": "Odpoveď",

  "role.actions.delete.button.trigger.text": "Vymazať",
  "role.actions.delete.confirm.title": "Rola bude vymazaná",
  "role.actions.delete.content.text": "Túto akciu nemožno vrátiť späť.",
  "role.actions.delete.content.usage.text": "Počet používateľov s touto rolou: {count}",
  "role.actions.delete.error.text": "Rolu sa nepodarilo vymazať.",
  "role.actions.delete.toast.success.text": "Rola bola úspešne vymazaná.",
  "role.evidence.table.title": "Roly",
  "role.fields.title.label": "Názov",
  "role.tabs.base-info": "Základné informácie",
  "role.tabs.permission": "Oprávnenia",

  "schedule.job.actions.start.button.trigger.tooltip": "Spustiť",
  "schedule.job.actions.start.content.text": "Naozaj chcete spustiť plánovanú úlohu?",
  "schedule.job.actions.start.title": "Spustiť plánovanú úlohu",
  "schedule.job.actions.start.toast.success.text": "Plánovaná úloha bola spustená.",
  "schedule.job.actions.stop.button.trigger.tooltip": "Zastaviť",
  "schedule.job.actions.stop.content.text": "Naozaj chcete zastaviť plánovanú úlohu?",
  "schedule.job.actions.stop.title": "Zastaviť plánovanú úlohu",
  "schedule.job.actions.stop.toast.success.text": "Plánovaná úloha bola zastavená.",
  "schedule.job.columns.last.label": "Posledný beh",
  "schedule.job.columns.log-action.label": "Zaznamenávanie",
  "schedule.job.columns.next.label": "Ďalší beh",
  "schedule.job.columns.script-type.label": "Typ skriptu",
  "schedule.job.columns.timer.label": "Časovač",
  "schedule.job.columns.title.label": "Názov",
  "schedule.job.detail.tab.base-info": "Základné informácie",
  "schedule.job.evidence.table.title": "Plánované úlohy",
  "schedule.job.fields.active.label": "Aktívny",
  "schedule.job.fields.last.label": "Posledný beh",
  "schedule.job.fields.log-action.label": "Zaznamenávanie",
  "schedule.job.fields.next.label": "Ďalší beh",
  "schedule.job.fields.running.label": "Práve beží",
  "schedule.job.fields.script-type.label": "Typ skriptu",
  "schedule.job.fields.script.label": "Skript",
  "schedule.job.fields.timer.label": "Časovač",
  "schedule.job.fields.title.label": "Názov",
  "schedule.job.fields.use-transaction.label": "V transakcii",
  "schedule.job.log-action.always": "Vždy",
  "schedule.job.log-action.never": "Nikdy",
  "schedule.job.log-action.on-error": "Pri chybe",
  "schedule.job.script-type.groovy": "Groovy",
  "schedule.job.script-type.javascript": "JavaScript",
  "schedule.job.tabs.base-info.group.title": "Základné informácie",
  "schedule.run.columns.end-time.label": "Koniec",
  "schedule.run.columns.job.label": "Úloha",
  "schedule.run.columns.start-time.label": "Začiatok",
  "schedule.run.columns.state.label": "Stav",
  "schedule.run.detail.tab.base-info": "Základné informácie",
  "schedule.run.evidence.table.title": "Záznamy",
  "schedule.run.fields.console.label": "Konzola",
  "schedule.run.fields.end-time.label": "Koniec",
  "schedule.run.fields.job.action.detail.tooltip": "Detail úlohy",
  "schedule.run.fields.job.group.title": "Úloha",
  "schedule.run.fields.job.title.label": "Názov",
  "schedule.run.fields.result.label": "Výsledok",
  "schedule.run.fields.start-time.label": "Začiatok",
  "schedule.run.fields.state.label": "Stav",
  "schedule.run.state.error": "Chyba",
  "schedule.run.state.finished": "Ukončený",
  "schedule.run.state.started": "Spustený",
  "schedule.run.tabs.base-info.group.title": "Základné informácie",

  "sentry-test.menu.title": "Test Sentry",

  "subject.actions.create.buttons.create.text": "Vytvoriť subjekt",
  "subject.actions.create.buttons.trigger.text": "Vytvoriť subjekt",
  "subject.actions.create.title": "Nový subjekt",
  "subject.actions.create.toast.success": "Subjekt bol vytvorený",
  "subject.actions.identify.buttons.select.text": "Vybrať",
  "subject.actions.identify.buttons.trigger.tooltip": "Stotožniť subjekt",
  "subject.actions.identify.columns.actions.label": "Akcie",
  "subject.actions.identify.columns.name.label": "Názov",
  "subject.actions.identify.columns.type.label": "Typ",
  "subject.actions.identify.empty.text": "Nenašli sa žiadne subjekty.",
  "subject.actions.identify.error.text": "Vyhľadávanie v registroch zlyhalo. Skúste to, prosím, znova.",
  "subject.actions.identify.loading.text": "Vyhľadávam subjekty...",
  "subject.actions.identify.more-results-lower-bound.text": "Nájdených viac ako {found} subjektov, zobrazených {shown}. Upresnite vyhľadávanie.",
  "subject.actions.identify.more-results.text": "Nájdených {found} subjektov, zobrazených {shown}. Upresnite vyhľadávanie.",
  "subject.actions.identify.preview.buttons.trigger.tooltip": "Detail subjektu",
  "subject.actions.identify.preview.title": "Detail subjektu",
  "subject.actions.identify.registry-message.text": "Odpoveď registra: {message}",
  "subject.actions.identify.title": "Stotožniť subjekt",
  "subject.actions.identify.toast.success": "Subjekt bol stotožnený",
  "subject.actions.preview.buttons.trigger.tooltip": "Detail subjektu",
  "subject.actions.preview.title": "Detail subjektu",
  "subject.actions.reset.buttons.trigger.tooltip": "Zrušiť subjekt",
  "subject.actions.update.buttons.trigger.text": "Upraviť subjekt",
  "subject.actions.update.buttons.update.text": "Uložiť",
  "subject.actions.update.title": "Upraviť subjekt",
  "subject.actions.update.toast.success": "Subjekt bol upravený",
  "subject.business-natural-person.fields.business-name.label": "Názov",
  "subject.business-natural-person.fields.first-name.label": "Meno",
  "subject.business-natural-person.fields.ico.label": "IČO",
  "subject.business-natural-person.fields.last-name.label": "Priezvisko",
  "subject.business-natural-person.identification-hint.text": "Na stotožnenie vyplňte aspoň IČO alebo časť názvu spoločnosti.",
  "subject.business-natural-person.tabs.business-natural-person.title": "Fyzická osoba – podnikateľ",
  "subject.columns.id": "ID",
  "subject.columns.name": "Názov",
  "subject.columns.type": "Typ",
  "subject.correspondence-contact.fields.email.label": "E-mail",
  "subject.correspondence-contact.fields.phone.label": "Telefón",
  "subject.correspondence-contact.group.title": "Korešpondenčný kontakt",
  "subject.detail.base-info": "Základné informácie",
  "subject.evidence.table.title": "Subjekty",
  "subject.fields.automatic-identification.label": "Automatické stotožnenie",
  "subject.fields.identified-at.label": "Stotožnené dňa",
  "subject.fields.note.label": "Poznámka",
  "subject.fields.type.label": "Typ subjektu",
  "subject.fields.upvs.label": "Schránka UPVS",
  "subject.form.search.actions.identified.label": "Stotožnený",
  "subject.form.search.field.label": "Subjekt",
  "subject.form.search.title": "Subjekt",
  "subject.legal-entity.fields.business-name.label": "Názov",
  "subject.legal-entity.fields.establishment-date.label": "Dátum založenia",
  "subject.legal-entity.fields.ico.label": "IČO",
  "subject.legal-entity.fields.legal-form.label": "Právna forma",
  "subject.legal-entity.fields.termination-date.label": "Dátum ukončenia",
  "subject.legal-entity.identification-hint.text": "Na stotožnenie vyplňte aspoň IČO alebo časť názvu spoločnosti.",
  "subject.legal-entity.tabs.legal-entity": "Právnická osoba",
  "subject.natural-person.fields.birth-last-name.label": "Rodné priezvisko",
  "subject.natural-person.fields.birth-number.label": "Rodné číslo",
  "subject.natural-person.fields.citizenships.label": "Národnosť",
  "subject.natural-person.fields.date-of-birth.label": "Dátum narodenia",
  "subject.natural-person.fields.date-of-death.label": "Dátum úmrtia",
  "subject.natural-person.fields.email.label": "E-mail",
  "subject.natural-person.fields.first-name.label": "Meno",
  "subject.natural-person.fields.gender.label": "Pohlavie",
  "subject.natural-person.fields.last-name.label": "Priezvisko",
  "subject.natural-person.fields.passport-number.label": "Číslo pasu",
  "subject.natural-person.fields.phone.label": "Telefón",
  "subject.natural-person.fields.title-after.label": "Titul za menom",
  "subject.natural-person.fields.titles-before.label": "Titul pred menom",
  "subject.natural-person.identification-hint.text": "Na stotožnenie vyplňte aspoň meno a priezvisko, rodné číslo alebo priezvisko a dátum narodenia.",
  "subject.natural-person.tabs.natural-person": "Fyzická osoba",
  "subject.tabs.addresses.actions.add": "Pridať adresu",
  "subject.tabs.addresses.title": "Adresy",
  "subject.tabs.base-info": "Základné informácie",
  "subject.type.businessNaturalPerson": "Fyzická osoba – podnikateľ",
  "subject.type.legalEntity": "Právnická osoba",
  "subject.type.naturalPerson": "Fyzická osoba",

  "timeago.days": "{value} d",
  "timeago.days-ago": "pred {value, plural, =1 {# dňom} other {# dňami}}",
  "timeago.hours": "{value} hod",
  "timeago.hours-ago": "pred {value, plural, =1 {# hodinou} other {# hodinami}}",
  "timeago.just-now": "práve teraz",
  "timeago.minutes": "{value} min",
  "timeago.minutes-ago": "pred {value, plural, =1 {# minútou} other {# minútami}}",
  "timeago.now": "teraz",

  "upvs-form.detail.fields.fo-xsl-schema": "Transformácia FO XSL",
  "upvs-form.detail.fields.html-xslt-schema": "Transformácia HTML XSLT",
  "upvs-form.detail.groups.basic-info.title": "Základné údaje",
  "upvs-form.detail.no-mapping.warning": "Formulár UPVS neobsahuje žiadne prvky IQ.",
  "upvs-form.detail.tabs.basic-info.label": "Základné údaje",
  "upvs-form.evidence.table.title": "Formuláre UPVS",

  "user.actions.logout.button.trigger.text": "Odhlásiť sa",
  "user.actions.sync-organizational-structure.button.trigger.text": "Synchronizovať organizačnú štruktúru",
  "user.actions.sync-organizational-structure.content.text": "Naozaj chcete synchronizovať organizačnú štruktúru?",
  "user.actions.sync-organizational-structure.toast.success.text": "Synchronizácia organizačnej štruktúry bola spustená",
  "user.columns.active.label": "Aktívny",
  "user.columns.first-name.label": "Meno",
  "user.columns.id.label": "Id",
  "user.columns.last-name.label": "Priezvisko",
  "user.columns.roles.label": "Roly",
  "user.columns.username.label": "Používateľské meno",
  "user.evidence.table.title": "Používatelia",
  "user.fields.roles.label": "Roly",
  "user.tabs.base-info": "Základné informácie"
}
